'use client';
import { SessionProvider } from 'next-auth/react';
import React, { ReactNode } from 'react';

import RefreshTokenHandler from '@/components/refreshTokenHandler';

interface NextAuthSessionProviderProps {
  children: ReactNode;
}

export default function NextAuthSessionProvider({
  children,
}: NextAuthSessionProviderProps) {
  const [interval, setInterval] = React.useState(0);
  return (
    <SessionProvider refetchInterval={interval}>
      <RefreshTokenHandler setInterval={setInterval} />
      {children}
    </SessionProvider>
  );
}
